export const getCurrentUserId = (state) => state.entities.users.currentUser?.id;
